<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p>I offer my sincere gratitude to my friends and well-wishers who have encouraged me in writing this short novel. A special mention should be given to my son Saril’s many suggestions, particularly his suggestion to add the last chapter, which, in retrospect, rounded off the story more satisfactorily.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?160f6140